import { memo } from 'react';

function PencilEditIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="#212B36"
        d="M9.5 15.127l6.164-6.163a8.575 8.575 0 01-2.772-1.862 8.577 8.577 0 01-1.863-2.772l-6.163 6.163c-.48.481-.722.722-.928.987a5.464 5.464 0 00-.624 1.01c-.145.302-.252.626-.467 1.27l-1.135 3.403a.883.883 0 001.118 1.119l3.403-1.135c.646-.215.968-.323 1.271-.467.359-.17.697-.38 1.01-.624.265-.207.505-.448.986-.929zm7.873-7.873A3.277 3.277 0 0012.74 2.62L12 3.36l.032.092a7.296 7.296 0 001.743 2.766 7.295 7.295 0 002.86 1.775l.738-.739z"
      ></path>
    </svg>
  );
}

export default memo(PencilEditIcon);

export function PencilEditIcon2({ color }: { color?: string }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="icon">
        <path
          id="icon_2"
          d="M5 19H6.425L16.2 9.225L14.775 7.8L5 17.575V19ZM3 21V16.75L16.2 3.575C16.4 3.39167 16.6208 3.25 16.8625 3.15C17.1042 3.05 17.3583 3 17.625 3C17.8917 3 18.15 3.05 18.4 3.15C18.65 3.25 18.8667 3.4 19.05 3.6L20.425 5C20.625 5.18333 20.7708 5.4 20.8625 5.65C20.9542 5.9 21 6.15 21 6.4C21 6.66667 20.9542 6.92083 20.8625 7.1625C20.7708 7.40417 20.625 7.625 20.425 7.825L7.25 21H3ZM15.475 8.525L14.775 7.8L16.2 9.225L15.475 8.525Z"
          fill={color || '#65558F'}
        />
      </g>
    </svg>
  );
}

export function PencilEditIcon3({ color }: { color?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M8 14L16 14" stroke={color || 'white'} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8 10L10 10" stroke={color || 'white'} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8 18L12 18" stroke={color || 'white'} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M10 3H6C4.89543 3 4 3.89543 4 5V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V5C20 3.89543 19.1046 3 18 3H14.5M10 3V1M10 3V5"
        stroke={color || 'white'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
